import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {AnalysisMainViewItemType, MainViewComponentProps} from 'analysis-tool/ui/main-view/MainViewTypes';
import {FONT_PROXIMA_13} from 'styles/FontConstants';
import {BLUE_LIGHT} from 'ui-library/Colors';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

export default function ChooseDifferentDataFrameCreationMethodButton({
  onOpenStepInitializationView,
}: Pick<MainViewComponentProps<AnalysisMainViewItemType>, 'onOpenStepInitializationView'>): JSX.Element {
  return (
    <div
      className={css(styles.wrapper)}
      onClick={() => {
        onOpenStepInitializationView({type: AnalysisMainViewItemType.CHOOSE_DATASET_CREATION_METHOD});
      }}
    >
      <BenchlingIcon icon="arrow-left" className={css(styles.icon)} />
      Choose different creation method
    </div>
  );
}

const styles = StyleSheet.create({
  wrapper: {
    ...FONT_PROXIMA_13,
    color: BLUE_LIGHT,
    cursor: 'pointer',

    alignItems: 'center',
    display: 'flex',
  },
  icon: {
    marginRight: 4,
  },
});
